export class MaintenanceChecklist {
  label: string;
  value: boolean;

  constructor(label: string, value: boolean) {
    this.label = label ?? "";
    this.value = value ?? false;
  }

  toObject() {
    return {
      label: this.label,
      value: this.value,
    };
  }
}